export const DashboardHeader = ({ userEmail, userRole, onLogout }) => {
    return (
        <div className="bg-slate-800 p-2 rounded-lg border border-slate-700 mb-2">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-base font-bold text-white">Bot Dashboard</h1>
                    <p className="text-xs text-slate-400">{userEmail} ({userRole})</p>
                </div>
                <button 
                    onClick={onLogout}
                    className="px-2.5 py-1 text-xs font-medium text-white bg-red-500 hover:bg-red-600 rounded transition-colors"
                >
                    Logout
                </button>
            </div>
        </div>
    );
};
